module.exports = new __parcel__URL__("icons8-css.c158a1a4.svg").toString();